module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "chapterTitle"
  }, [_c('a', {
    attrs: {
      "href": "#/toc01#chap_07",
      "id": "chap07"
    }
  }, [_vm._v("WHY IS BLOOD RED, NOT BLUE?")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterAuthor"
  }, [_vm._v("Dr Christian Jessen")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("medical doctor and broadcaster")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("You may have heard that kings and queens have blue blood. That would be funny, but I’m afraid it isn’t true. Nobody has blue blood. It’s always red.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I know that if you look closely at the veins in your arms it seems like they contain blue blood. But this is just because your veins are very close to the surface of your skin, and the skin only lets certain colours of light through it – so the blood inside appears blue from the outside. Inside your veins, though, it’s still red.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("What gives your blood its red colour? The colour comes from a very important chemical in blood called haemoglobin, which carries the oxygen from your lungs all around your body, giving you lots of energy to move. Although it is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("never")]), _vm._v(" blue, haemoglobin can change colour a bit. When there is lots of oxygen in your body, your haemoglobin will make your blood a nice bright red colour. If you are running and playing, your body uses up more oxygen and your blood becomes a much darker red, and is quickly pumped back to your lungs to get some more oxygen.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Some animals "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do")]), _vm._v(" have blue blood, however. Do you know which ones? Octopuses, squid, lobsters, cuttlefish and horseshoe crabs all have blue blood!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fcc3370","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap07.vue
// module id = 90
// module chunks = 0